export default __webpack_public_path__ + "./images/ad.f8fc0067.png";